import globalAxios, { type AxiosInstance, type AxiosPromise, type AxiosRequestConfig } from 'axios';
import type { Configuration } from './configuration';
import { BASE_PATH, BaseAPI } from './base';
import type { ResultVo } from './api';

export interface SaveAuthorizedDevicesRequest {
  adminId: number;
  deviceIds: number[];
  authorizeAllDevices?: boolean;
}

export interface AuthorizedDeviceInfo {
  authorizeAllDevices: boolean;
  deviceIds: number[];
}

export class AdminDeviceAuthApi extends BaseAPI {

  constructor(
    configuration?: Configuration,
    basePath: string = BASE_PATH,
    axios: AxiosInstance = globalAxios,
  ) {
    super(configuration, basePath, axios);
  }

  public listAuthorizedDeviceIds(
    adminId: number,
    options?: AxiosRequestConfig,
  ): AxiosPromise<ResultVo> {
    return this.axios.request<ResultVo>({
      ...(options || {}),
      method: 'GET',
      url: `${this.basePath}/adminDeviceAuth/listAuthorizedDeviceIds`,
      params: { adminId },
    });
  }

  public getAuthorizedDeviceInfo(
    adminId: number,
    options?: AxiosRequestConfig,
  ): AxiosPromise<ResultVo> {
    return this.axios.request<ResultVo>({
      ...(options || {}),
      method: 'GET',
      url: `${this.basePath}/adminDeviceAuth/getAuthorizedDeviceInfo`,
      params: { adminId },
    });
  }

  public saveAuthorizedDevices(
    request: SaveAuthorizedDevicesRequest,
    options?: AxiosRequestConfig,
  ): AxiosPromise<ResultVo> {
    return this.axios.request<ResultVo>({
      ...(options || {}),
      method: 'POST',
      url: `${this.basePath}/adminDeviceAuth/saveAuthorizedDevices`,
      headers: {
        'Content-Type': 'application/json',
        ...((options && options.headers) || {}),
      },
      data: request,
    });
  }

}
